import React from "react";

const Tutorial = () => {
  return (
    <div
      id="tutorial"
      style={{ backgroundImage: "url(/imgs/etc/bg.jpg)" }}
      className="fixed w-[100vw] h-[100vh] top-0 left-0 bg-cover text-white flex items-center justify-between px-28 z-50 bg-[#FF8F79]"
    >
      <div className="flex flex-col items-center justify-center w-full h-full">
        <p className="mb-6 text-8xl bold">Welcome to inDJ!</p>
        <p className="text-5xl leading-tight text-[#e1e1e1]">
          The AI provide musiclist by your Feelings.
        </p>
      </div>
    </div>
  );
};

export default Tutorial;
